module.exports = __webpack_public_path__ + "static/media/HomeStoryImage2.57623711.jpg";